import pinwheel from '../elements/pinwheel.js';
pinwheel.register();
